/* eslint import/no-unresolved: 0 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useToggle } from '@openedx/paragon';

import { useModel } from '@src/generic/model-store';
import { useContextId } from '@src/data/hooks';
import NextButton from '@src/courseware/course/sequence/sequence-navigation/generic/NextButton';
import { useInCourseUpgradeModal, useIsModalEnabled } from './hooks';
import UpgradeModal from './UpgradeModal';

const NextUnitButton = ({
  disabled,
  buttonText,
  sequenceId,
  onClickHandler,
  nextLink,
  variant,
  buttonStyle,
  isAtTop,
}) => {
  const courseId = useContextId();
  const [isOpen, open, close] = useToggle(false);
  const {
    verifiedMode,
    org,
  } = useModel('courseHomeMeta', courseId);

  const {
    offer,
    marketingUrl,
    accessExpiration,
    datesBannerInfo,
    learningAssistantEnabled,
  } = useModel('coursewareMeta', courseId);

  const isEnabled = useIsModalEnabled(courseId);
  const [shouldShowModalOnClick, countNextClick] = useInCourseUpgradeModal();

  const handleModal = () => {
    if (isEnabled) {
      countNextClick();
      if (shouldShowModalOnClick) {
        open();
      }
    }
  };

  useEffect(() => {
    handleModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequenceId]);

  return (
    <>
      <NextButton
        onClickHandler={onClickHandler}
        nextLink={nextLink}
        variant={variant}
        buttonStyle={buttonStyle}
        buttonText={buttonText}
        disabled={disabled}
        isAtTop={isAtTop}
      />
      {isOpen && (
        <UpgradeModal
          {...{
            isOpen,
            close,
            verifiedMode,
            org,
            courseId,
            offer,
            marketingUrl,
            accessExpiration,
            datesBannerInfo,
            learningAssistantEnabled,
          }}
        />
      )}
    </>
  );
};

NextUnitButton.defaultProps = {
  isAtTop: false,
};

NextUnitButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  nextLink: PropTypes.string.isRequired,
  sequenceId: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  unitId: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  courseId: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string.isRequired,
  isAtTop: PropTypes.bool,
};

export default NextUnitButton;
